// Converts a value to the unit a dataset column is labelled with ("Voltage (kV)", ...).
// Mirrors backend UnitNormalizer.java: contributors may enter V, µL/min, mm, K, µm,
// GPa, ...; tables, filters and exports must compare like with like.

const FACTORS = {
    VOLTAGE: { kV: 1, kv: 1, KV: 1, V: 0.001, v: 0.001 },
    FLOW_RATE: { 'mL/h': 1, 'mL/hr': 1, 'ml/h': 1, 'ml/hr': 1, 'µL/min': 0.06, 'ul/min': 0.06, 'µL/h': 0.001, 'mL/min': 60, 'ml/min': 60, 'µL/s': 3.6 },
    LENGTH_CM: { cm: 1, CM: 1, mm: 0.1, m: 100, 'µm': 0.0001 },
    PERCENT: { '%': 1 },
    FIBER_SIZE: { nm: 1, 'µm': 1000, um: 1000, mm: 1000000 },
    STRESS: { MPa: 1, GPa: 1000, kPa: 0.001, Pa: 0.000001 },
    AREA_PER_MASS: { 'm²/g': 1, 'm2/g': 1 },
};

/** Column header -> quantity of its unit. Headers without a unit are left as recorded. */
export const HEADER_QUANTITY = {
    'Voltage (kV)': 'VOLTAGE',
    'Flow Rate (mL/h)': 'FLOW_RATE',
    'Tip Dist (cm)': 'LENGTH_CM',
    'Temperature (°C)': 'TEMPERATURE',
    'Humidity (%)': 'PERCENT',
    'Fiber Diameter (nm)': 'FIBER_SIZE',
    'Diameter Variation': 'FIBER_SIZE',
    'Tensile Strength (MPa)': 'STRESS',
    'Modulus (MPa)': 'STRESS',
    'Elongation at Break (%)': 'PERCENT',
    'Surface Area (m²/g)': 'AREA_PER_MASS',
    'Porosity (%)': 'PERCENT',
};

const round = (v) => {
    if (v === 0) return 0;
    const scale = Math.pow(10, 10 - Math.ceil(Math.log10(Math.abs(v))));
    return Math.round(v * scale) / scale;
};

/**
 * The value in the quantity's canonical unit, or null when it cannot be converted.
 * A value without a unit is taken to be in the form's default unit, which is the canonical one.
 */
export function toCanonical(quantity, value, unit) {
    if (value === null || value === undefined || value === '' || value === '-') return null;
    const num = Number(value);
    if (Number.isNaN(num)) return null;
    const u = (unit === null || unit === undefined || unit === '-') ? '' : String(unit).trim().replace('μ', 'µ');
    if (!u) return num;
    if (quantity === 'TEMPERATURE') {
        const t = u.replace('º', '°').toUpperCase();
        if (['°C', 'C', 'DEGC'].includes(t)) return num;
        if (t === 'K') return round(num - 273.15);
        if (['°F', 'F'].includes(t)) return round((num - 32) * 5 / 9);
        return null;
    }
    const factor = FACTORS[quantity]?.[u];
    return factor === undefined ? null : round(num * factor);
}
